import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.7_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_reac_15c8be349baff2f6069e0a6cc60f58ff/node_modules/next/dist/client/script.js");
